import { UPDATE_HREFLANG } from 'shared/constants/hreflang';

const initialState = {
  clicked: false,
};

/**
 * Reducer for handling hreflang updates.
 *
 * @param {Object} state - The current state.
 * @param {Object} action - The dispatched action.
 * @returns {Object} The new state.
 */
export function hreflang(state = initialState, action = {}) {
  switch (action.type) {
    case UPDATE_HREFLANG:
      return {
        ...state,
        clicked: action.payload.clicked,
      };
    default:
      return state;
  }
}
